import { OrdersTableTab } from '@ekhodealer/ekho-common';
import { Tag } from '@ekhodealer/ekho-common/rev';

/**
 * Map orders table tab to Tag accent color
 * Uses the raw tab value (before formatting) to determine color
 */
const getTabAccent = (tab: string | undefined): 'neutral' | 1 | 2 | 3 | 4 | 5 | 6 | 7 => {
	if (!tab) return 'neutral';

	// Convert formatted tab back to normalized form for color mapping
	const normalizedTab = tab.toLowerCase().replace(/\s+/g, '-');

	switch (normalizedTab) {
		case OrdersTableTab.PENDING:
			return 6;
		case OrdersTableTab.CANCELED:
			return 'neutral';
		case OrdersTableTab.KICK_OFF_FULFILLMENT:
			return 1; // Blue
		case OrdersTableTab.SALES_PROCESSING:
			return 5; // Orange
		case OrdersTableTab.IN_FULFILLMENT:
			return 2; // Purple
		case OrdersTableTab.FULFILLED:
			return 3; // Teal/Green
		default:
			return 'neutral';
	}
};

interface OrderTabCellProps {
	tab: string | undefined;
}

export const OrderTabCell = ({ tab }: OrderTabCellProps) => {
	const tabText = tab || '—';
	const accent = getTabAccent(tab);

	return (
		<div style={{ minWidth: '140px' }}>
			<Tag size='medium' accent={accent} children={tabText} />
		</div>
	);
};
